<template>
  <div>
    <div class="bj">
      <img src="../../img/home/lgbj.png" alt="" class="loginbj" />
      <img
        src="../../img/home/return.png"
        alt=""
        class="return"
        @click="gosy()"
      />
      <img src="../../img/home/dxyz.png" alt="" class="dxyz" />
      <div
        id="login"
        style="position: absolute; top: 63vw; width: 76vw; left: 12vw"
      >
        <van-cell-group style="position: relative">
          <van-field
            v-model="phone"
            maxlength="11"
            type="digit"
            label=""
            placeholder="请输入手机号"
          />
          <img src="../../img/home/phone.png" alt="" class="phone" />
        </van-cell-group>
        <van-cell-group id="loginyzm" style="position: relative; top: 5vw">
          <van-field
            v-model="yzm"
            maxlength="6"
            type="digit"
            label=""
            placeholder="请输入验证码"
          />
          <img src="../../img/home/carbon.png" alt="" class="carbon" />
          <div class="yzm">
            <div style="float: left; font-size: 5vw; width: 10%">|</div>
            <div v-if="isSend" class="yzmtxt" @click="send()">
              {{ sendmsg }}
            </div>
            <div v-if="!isSend" class="yzmdjs">{{ sendmsg }}</div>
          </div>
        </van-cell-group>
      </div>
      <van-button
        class="van-zdy"
        type="primary"
        color="#1989fa"
        @click="login()"
        >登录</van-button
      >
    </div>
  </div>
</template>

<script>
import config from "../../../config/config.js";
import { sendmsm, checkmsmyzm, updopenid } from "../../api/ZghApi/ZghAx";
export default {
  data() {
    return {
      phone: "",
      yzm: "",
      sendmsg: "获取验证码",
      isSend: true,
      timeFun: "",
    };
  },
  components: {},
  created() {},
  destroyed() {},
  computed: {},
  mounted() {},
  methods: {
    login() {
      if (!this.phone) {
        this.$toast("请填写手机号！");
        return;
      } else if (/^1(3|4|5|6|7|8)\d{9}$/.test(this.phone) == false) {
        this.$toast("请填写正确的手机号！");
        return;
      } else if (!this.yzm) {
        this.$toast("请填写验证码！");
        return;
      }
      checkmsmyzm({ phone: this.phone, yzm: this.yzm }).then((res) => {
        if (res.state == "ok") {
          updopenid({
            phone: this.phone,
            openid: localStorage.getItem("openid"),
          }).then((res) => {
            if (res.state == "ok") {
              localStorage.setItem("tel", this.phone);
              this.$router.push({ name: "Home" });
              this.$toast("登录成功！");
            } else {
              this.$toast("登入失败，请联系管理员！");
            }
          });
        } else if (res.state == "notfind") {
          this.$toast("验证码错误！");
        } else if (res.state == "err") {
          this.$toast("登入失败，请联系管理员！");
        }
      });
    },
    gosy() {
      this.$router.push({ name: "Home" });
    },
    formateTime(time) {
      const h = parseInt(time / 3600);
      const minute = parseInt((time / 60) % 60);
      const second = Math.ceil(time % 60);

      const hours = h < 10 ? "0" + h : h;
      const formatSecond = second > 59 ? 59 : second;
      return `${hours > 0 ? `${hours}时` : ""}${
        minute < 10 ? "0" + minute : minute
      }分${formatSecond < 10 ? "0" + formatSecond : formatSecond}秒`;
    },
    send() {
      if (!this.phone) {
        this.$toast("请填写手机号后获取验证码！");
      } else if (/^1(3|4|5|6|7|8)\d{9}$/.test(this.phone) == false) {
        this.$toast("请填写正确的手机号后获取验证码！");
      } else {
        sendmsm({ phone: this.phone }).then((res) => {
          if (res.state == "ok") {
            this.isSend = false;
            let timer = 60;
            this.sendmsg = "已发送(" + timer + "s)";
            this.timeFun = setInterval(() => {
              --timer;
              this.sendmsg = "已发送(" + timer + "s)";
              if (timer == 0) {
                this.isSend = true;
                this.sendmsg = "获取验证码";
                clearInterval(this.timeFun);
              }
            }, 1000);
          } else if (res.state == "notfind") {
            this.$dialog
              .alert({
                message: "用户不存在，请拨打热线0591-8282517！",
              })
              .then(() => {
                //   this.$router.push({ name: "Home" });
              });
          } else if (res.state == "validity") {
            this.$toast("请在" + this.formateTime(res.time) + "后重新发送！");
          } else if (res.state == "restricted") {
            this.$toast("今日获取验证码次数已达到上限！");
          } else if (res.state == "err") {
            this.$toast("获取验证码失败，请联系管理员！");
          }
        });
      }
    },
  },
};
</script>
<style scoped >
.bj {
  width: 100vw;
  overflow: hidden;
}
.return {
  width: 9vw;
  position: absolute;
  top: 9vw;
  left: 1vw;
}
.loginbj {
  width: 100vw;
  position: absolute;
  top: 0vw;
  left: 0vw;
}
.dxyz {
  width: 88vw;
  height: 75vw;
  position: absolute;
  top: 53vw;
  left: 6vw;
}
#login >>> .van-cell-group {
  border-radius: 10px !important;
}
#login >>> .van-cell {
  border-radius: 10px !important;
}
.van-zdy {
  position: absolute;
  top: 110vw;
  width: 78vw;
  left: 11vw;
  border-radius: 10px;
}
.phone {
  position: absolute;
  width: 6vw;
  top: 2vw;
  left: 3vw;
}
.carbon {
  position: absolute;
  width: 5vw;
  top: 2.5vw;
  left: 3vw;
}
#login >>> .van-field__body {
  margin-left: 7vw !important;
}
#loginyzm >>> .van-field__body {
  width: 30vw;
}
.yzm {
  position: absolute;
  top: 0vw;
  right: 0vw;
  width: 28vw;
  height: 100%;
  display: flex;
  align-items: center;
}
.yzmtxt {
  float: left;
  font-size: 4vw;
  width: 80%;
  top: 0vw;
  text-align: center;
  position: relative;
}
.yzmdjs {
  float: left;
  font-size: 4vw;
  width: 80%;
  top: 0vw;
  left: 1vw;
  /* text-align: center; */
  position: relative;
  color: gray;
}
</style>



// WEBPACK FOOTER //
// src/views/Home/login.vue